import React from "react";
import { Box, Paper, Typography, Container } from "@mui/material";

const PurchaseHistory = () => {
  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "transparent",
          padding: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 4,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
          >
            Purchase History
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: "1.2rem", textAlign: "center", color: "#555" }}
          >
            Thank you for visiting and taking the time to check your purchase
            history. Here, you can view all your past purchases, leave reviews,
            and download reports, invoices for each transaction.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            If your purchase was for a AI based consultation insights, you will
            have entire report of proofs of prediction, statistics, in the form
            of a downloadable report, with gives probability for each prediction
            mathematically. consultations.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            If your purchase was for a consultation service, you'll have access
            to the deliverables: audio recordings for phone consultations, video
            recordings for video calls, and chat history for text-based
            consultations.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "#555",
              marginTop: 2,
            }}
          >
            This page is part of a bigger vision for the platform. I’m
            constantly working to improve and expand the system, and I welcome
            any feedback you may have.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default PurchaseHistory;
